import { render, staticRenderFns } from "./RequiredBadge.vue?vue&type=template&id=51e0dac6&"
import script from "./RequiredBadge.vue?vue&type=script&lang=js&"
export * from "./RequiredBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports